// extracted by mini-css-extract-plugin
var _1 = "QMgZiU1OBH7RWzCVdjzN";
export { _1 as "table-container" }
